export const nbsp = String.fromCharCode(160);
export const mdash = String.fromCharCode(8212);
